import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBaselineAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25001 11.25C6.25001 11.6642 6.58579 12 7.00001 12C7.41422 12 7.75001 11.6642 7.75 11.25L7.75001 8.75001L10.25 8.75001C10.6642 8.75001 11 8.41423 11 8.00001C11 7.5858 10.6642 7.25001 10.25 7.25001L7.75001 7.25001L7.75 4.75C7.75001 4.33579 7.41422 4 7.00001 4C6.58579 4 6.25001 4.33579 6.25001 4.75L6.25001 7.25001L3.75 7.25001C3.33579 7.25001 3 7.5858 3 8.00001C3 8.41422 3.33579 8.75001 3.75 8.75001L6.25001 8.75001L6.25001 11.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5303 7.53033C18.8232 7.23744 18.8232 6.76256 18.5303 6.46967C18.2374 6.17678 17.7626 6.17678 17.4697 6.46967L5.46967 18.4697C5.17678 18.7626 5.17678 19.2374 5.46967 19.5303C5.76256 19.8232 6.23744 19.8232 6.53033 19.5303L18.5303 7.53033Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 18.75C13.3358 18.75 13 18.4142 13 18C13 17.5858 13.3358 17.25 13.75 17.25H20.25C20.6642 17.25 21 17.5858 21 18C21 18.4142 20.6642 18.75 20.25 18.75H13.75Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconBaselineAlt as ReactComponent };
